import React, { useState } from 'react';
import { Layout as AntLayout, Menu, Button, Avatar, Dropdown, Space, Typography, theme, Modal } from 'antd';
import { 
  MenuFoldOutlined, 
  MenuUnfoldOutlined, 
  DashboardOutlined,
  AppstoreOutlined,
  MonitorOutlined,
  TeamOutlined,
  LogoutOutlined,
  UserOutlined,
  SettingOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // ✅ NUEVO

const { Header, Sider, Content } = AntLayout;
const { Title, Text } = Typography;

const Layout = ({ children }) => { // ✅ ARREGLADO: Sin props de auth
  const [collapsed, setCollapsed] = useState(false);
  const [aboutModalVisible, setAboutModalVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = theme.useToken();
  
  // ✅ NUEVO: Usar AuthContext
  const { user, logout } = useAuth();

  // Determinar si es móvil
  const isMobile = window.innerWidth <= 768;

  // ✅ ARREGLADO: Usar logout del AuthContext
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error en logout:', error);
    }
  };

  // Items del menú principal
  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/dashboard')
    },
    {
        key: '/monitoreo',
        icon: <MonitorOutlined />,
        label: 'Monitoreo del Sistema',
        onClick: () => navigate('/monitoreo')
      },
    {
      key: '/conjuntos',
      icon: <AppstoreOutlined />,
      label: 'Gestión de Conjuntos',
      onClick: () => navigate('/conjuntos')
    },
    
    {
      key: '/usuarios-admin',
      icon: <TeamOutlined />,
      label: 'Usuarios Administradores',
      onClick: () => navigate('/usuarios-admin')
    }
  ];

  // ✅ ARREGLADO: Menú del usuario
  const userMenuItems = [
    {
      key: 'perfil',
      icon: <UserOutlined />,
      label: 'Mi Perfil',
      onClick: () => navigate('/perfil')
    },
    {
      key: 'configuracion',
      icon: <SettingOutlined />,
      label: 'Configuración',
      onClick: () => navigate('/configuracion')
    },
    {
      key: 'acerca',
      icon: <InfoCircleOutlined />,
      label: 'Acerca del Sistema',
      onClick: () => setAboutModalVisible(true)
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Cerrar Sesión',
      onClick: handleLogout, // ✅ ARREGLADO: Función correcta
      danger: true
    }
  ];

  const selectedKey = location.pathname;

  return (
    <>
      <AntLayout style={{ minHeight: '100vh' }}>
        {/* Sidebar */}
        <Sider 
          trigger={null} 
          collapsible 
          collapsed={collapsed}
          style={{
            background: token.colorBgContainer,
            borderRight: `1px solid ${token.colorBorder}`,
            position: isMobile ? 'fixed' : 'relative',
            left: isMobile ? (collapsed ? -200 : 0) : undefined,
            zIndex: isMobile ? 100 : 1,
            height: '100vh',
            overflow: 'auto'
          }}
          width={200}
          collapsedWidth={80}
        >
          <div style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: `1px solid ${token.colorBorder}`,
            background: token.colorBgContainer
          }}>
            <Title level={5} style={{ 
              margin: 0, 
              color: token.colorPrimary,
              display: collapsed && !isMobile ? 'none' : 'block'
            }}>
              HOREB
            </Title>
          </div>

          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            style={{
              border: 'none',
              background: token.colorBgContainer
            }}
          />
        </Sider>

        {isMobile && !collapsed && (
  <div 
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 99
    }}
    onClick={() => setCollapsed(true)}
  />
)}

        {/* Layout principal */}
        <AntLayout style={{ 
          marginLeft: isMobile ? 0 : undefined 
        }}>
          {/* Header */}
          <Header style={{ 
            padding: isMobile ? '0 16px' : '0 24px', 
            background: token.colorBgContainer,
            borderBottom: `1px solid ${token.colorBorder}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: isMobile ? 'fixed' : 'relative',
            top: 0,
            zIndex: 99,
            width: '100%'
          }}>
            <Space>
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{ display: 'flex' }}
              />
              
              <Title level={4} style={{ margin: 0 }}>
                Sistema Multitenant HOREB
              </Title>
            </Space>

            <Space>
              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
                trigger={['click']}
              >
                <Button type="text" style={{ height: 'auto', padding: '4px 8px' }}>
                  <Space>
                    <Avatar 
                      size="small" 
                      icon={<UserOutlined />} 
                      style={{ backgroundColor: '#1890ff' }}
                    />
                    {!isMobile && (
                      <div style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: '14px', fontWeight: 500 }}>
                          {/* ✅ ARREGLADO: Mostrar datos reales del usuario */}
                          {user?.nombre_persona || 'Usuario'}
                        </div>
                        <div style={{ fontSize: '12px', color: token.colorTextSecondary }}>
                          {user?.rol || 'Sin rol'}
                        </div>
                      </div>
                    )}
                  </Space>
                </Button>
              </Dropdown>
            </Space>
          </Header>

          {/* Contenido */}
          <Content style={{
            margin: isMobile ? '64px 16px 16px' : '24px',
            padding: isMobile ? '16px' : '24px',
            minHeight: 280,
            marginTop: isMobile ? '72px' : '24px',
            transition: 'all 0.2s',
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            border: `1px solid ${token.colorBorder}`
          }}>
            {children}
          </Content>

          {/* Footer del desarrollador */}
          <div style={{
            background: token.colorBgLayout,
            padding: isMobile ? '12px 16px' : '16px 24px',
            borderTop: `1px solid ${token.colorBorder}`,
            textAlign: 'center',
            fontSize: '12px',
            color: token.colorTextSecondary,
            marginLeft: isMobile ? 0 : (collapsed ? 80 : 200)
          }}>
            <Text type="secondary">
              Desarrollado por Horeb Apps © 2025 | Portal Administrativo Central
            </Text>
          </div>
        </AntLayout>
      </AntLayout>

      {/* Modal Acerca de */}
      <Modal
        title="Acerca del Sistema"
        open={aboutModalVisible}
        onCancel={() => setAboutModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setAboutModalVisible(false)}>
            Cerrar
          </Button>
        ]}
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Title level={4}>Sistema Multitenant HOREB</Title>
            <Text>Portal Administrativo Central</Text>
          </div>
          
          <div>
            <Text strong>Versión:</Text> 2.0.0<br />
            <Text strong>Desarrollado por:</Text> Horeb Apps<br />
            <Text strong>Año:</Text> 2025
          </div>
          
          <div>
            <Text type="secondary">
              Sistema de gestión centralizada para múltiples conjuntos residenciales
            </Text>
          </div>
        </Space>
      </Modal>
    </>
  );
};

export default Layout;